/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".flex-title[_ngcontent-%COMP%]{flex:1}.no-results[_ngcontent-%COMP%]{padding:20px;text-align:center}.mat-column-icon[_ngcontent-%COMP%]{flex:0 1 32px}.mat-column-actions[_ngcontent-%COMP%]{flex:0 1 280px}"];
export { styles as styles };
